import { render } from "./DocumentBrowserHome.vue?vue&type=template&id=71e82bb3&scoped=true&ts=true"
import script from "./DocumentBrowserHome.vue?vue&type=script&lang=ts"
export * from "./DocumentBrowserHome.vue?vue&type=script&lang=ts"

import "./DocumentBrowserHome.vue?vue&type=style&index=0&id=71e82bb3&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e82bb3"]])

export default __exports__